<div class="container-fluid">
  <app-header titleText="Dealer Latest Login" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
        <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null">
    <h5 i18n>Please provide report criteria</h5>
  </div>
  <div *ngIf="report">
    <div class="row header-text">
      <div class="col-md-4">
      </div>
      <div class="col-md-6 filter-zone">
        <p>
          <span i18n>REPORT DEFINED:</span><br />
          <span *ngIf='this.parameters.dealer_ID !== null'><span i18n>Dealer:</span> {{dealer.dealer_BusinessName}}<br /></span>
          <span *ngIf='this.parameters.dealer_ID === null'><span i18n>Dealer: All Dealers</span><br /></span>
          <span i18n>Status: {{this.status_Desc}}</span><br />
        </p>
      </div>

    </div>

    <div class="content">
      <div class="quote-month-summary">
        <h2 i18n>Contacts</h2>
        <div>
          <table class="table table-bidit">
            <thead>
              <tr>
                <th i18n>Dealer</th>
                <th i18n>Region</th>
                <th il8n>Saleperson</th>
                <th i18n>Created</th>
                <th i18n>Last Login Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let dealer of report">
                <td>{{dealer.dealer_BusinessName}}</td>
                <td>{{dealer.region_Desc}}</td>
                <td>{{dealer.salesperson}}</td>
                <td>{{dealer.dealer_Created | date : 'M/d/yyyy'}}</td>
                <td>{{dealer.last_Login_Date| date : 'M/d/yyyy'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

